import GenericModal from "./index";
import PillButton from "components/button/Pills";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entityName?: string;
  message?: string;
  title?: string;
  showDownloadWarning?: boolean;
}

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  entityName = "item",
  message,
  title = "Delete Confirmation",
  showDownloadWarning = false,
}: DeleteConfirmationModalProps) => {
  const defaultMessage = `Are you sure you want to delete this ${entityName}? Please confirm your action to proceed.`;
  const warningMessage = `Note: Before deleting, make sure that you have downloaded the media. Once deleted this action is permanent and cannot be undone.`;

  return (
    <GenericModal isOpen={isOpen} onClose={onClose} header={title} customWidth="md:w-96">
      {/* <div className="bg-white rounded-lg shadow-xl w-96 border border-gray-200"> */}
      <div className="px-6 py-5">
        <div className="flex items-start mb-4">
          <div className="flex-shrink-0">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
              />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-gray-800 dark:text-gray-200 text-base font-medium leading-relaxed">
              {message ?? defaultMessage}
            </p>
            {/* ✅ Show only when needed */}
            {showDownloadWarning && (
              <p className="mt-2 text-sm text-red-600">
                ⚠️ {warningMessage}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="bg-gray-50 dark:bg-gray-800 px-6 py-4 rounded-b-lg flex justify-end gap-3">
        <PillButton
          className="bg-white hover:bg-gray-50 text-gray-700 border border-gray-300"
          onClick={onClose}
        >
          Cancel
        </PillButton>
        <PillButton
          className="text-white bg-red-600 hover:bg-red-700"
          onClick={onConfirm}
        >
          Delete
        </PillButton>
      </div>
      {/* </div> */}
    </GenericModal>
  );
};

export default DeleteConfirmationModal;
